import { Protocol } from "./protocol.model";

/**NOTE
 * Needs to be maintained in sync with the device_type.go file
 */
export enum DeviceType {
    NoiseSensor = "noise_sensor",
    AcousticLimiter = "acoustic_limiter",
}

export class ActiveProjectModel {
    id: string;
    name: string;
}

export class DeviceFileModel {
    id: string;
    filename: string;
    status: string;
    originalName: string;
    originalDate?: Date;
    uploadDate: Date;
    source?: string;
    contentType?: string;
    size?: number;
}

export const DeviceFileStatus = {
    Uploaded: "uploaded",
    PendingReprocess: "pending_reprocess",
    Reprocessing: "reprocessing",
    ReprocessFailed: "reprocess_failed",
} as const;

export const DeviceFileSource = {
    SvantekSVL: "svantek_svl",
} as const;

export class DeviceModel {
    id: string;
    name: string;
    picture: string;
    manufacturer: string;
    model: string;
    serialNumber: string;
    dataFrequency: number;
    protocol?: Protocol = new Protocol();
    deviceType: DeviceType;
    simOrImei: string;
    lastCalibrationDate: Date;
    activeInProject: ActiveProjectModel;
}
